var chunkToChildrenMap = {
	"8066": [
		1869,
		204,
		4495,
		5364,
		8211,
		2562,
		4953
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));